const schemaMap = new Map();

const english = {
    title: 'Contact Support',
    form: {
        fName: { label: 'First Name' },
        lName: { label: 'Last Name' },
        nickname: { label: 'Nickname' },
        phoneNumber: { label: 'Phone Number' },
        email: { label: 'Email' },
        emailVerification: { label: 'Email Verification' },
        subject: {
            label: 'Issue Type',
            options: [
                { value: 1, text: "App Crashes" },
                { value: 2, text: "Billing" },
                { value: 3, text: "Features (album/quest/contests/missions)" },
                { value: 4, text: "Bonuses" },
                { value: 5, text: "Suggestions" }]
        },
        message: { label: 'Message' }
    },
    errors: {
        form: {
            requiredMessage: 'This filed is required.'
        },
        view: {
            title: 'Error',
            message: 'Something went wrong, please try again later'
        }
    },
    success: {
        view: {
            title: 'We got it!',
            message: "One of our support agents will get back to you as soon as possible! Don't forget to check your spam folder :)"
        }
    },
    formBottomText: "Please keep your message short and sweet :) you'll get a reply to your email, so please make sure your details are correct!",
    submitButton: 'Submit',
}

schemaMap.set('EN', english);

export default schemaMap;